import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import cn from 'classnames';
import CardBox from '../CardBox';
import { TP } from '../../constants/consts';
import { colors } from '../../constants/styleConstants';
import Button from '../Button';
import AppCircularProgress from '../AppCircularProgress/AppCircularProgress';
import ImageSet from '../ImageSet';
import DefaultProfileImage from '../../public/images/default-profile.jpg';
import TextButton from '../TextButton';
import DeleteFbIcon from '../Icons/DeleteFbIcon';
import ImageTag from '../ImageTag';

const useStyles = makeStyles(theme => ({
  card: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(),
    justifyContent: 'space-between',
    marginTop: theme.spacing(),
  },
  image: {
    border: '1px solid rgba(151, 151, 151, 0.32)',
    marginRight: '14px',
  },
  loadingBlock: {
    backgroundColor: colors.background.optionBg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  spinner: {
    color: colors.text,
  },
  buttonsBlock: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
  },
  deleteButton: {
    marginRight: theme.spacing(2),
  },
}));

export const ImageCard = ({ image, editFunc, contentClassName, loading, deleteFunc, src, rootClassName }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <CardBox className={cn(classes.card, rootClassName)}>
      {loading ? (
        <div className={cn(classes.loadingBlock, contentClassName)}>
          <AppCircularProgress className={classes.spinner} />
        </div>
      ) : (
        <ImageSet
          images={image}
          isDefault={!image}
          defaultImage={<ImageTag src={DefaultProfileImage} alt="img" />}
          className={contentClassName}
          src={src}
        />
      )}
      <div className={classes.buttonsBlock}>
        {deleteFunc && (image || src) && (
          <TextButton className={classes.deleteButton} onClick={deleteFunc} startIcon={<DeleteFbIcon />}>
            {t(`${TP}.m_DELETE`)}
          </TextButton>
        )}
        {editFunc && (
          <Button
            color="default"
            startIcon={<EditIcon style={{ fill: colors.blue }} />}
            onClick={() => editFunc(image)}
          >
            {t(`${TP}.m_EDIT`)}
          </Button>
        )}
      </div>
    </CardBox>
  );
};

ImageCard.propTypes = {
  image: PropTypes.object,
  editFunc: PropTypes.func,
  loading: PropTypes.bool,
  contentClassName: PropTypes.string,
  rootClassName: PropTypes.string,
};

ImageCard.defaults = {
  loading: false,
  contentClassName: '',
  rootClassName: '',
};

export default memo(ImageCard);
